<template>
  <el-dialog
    top="80px"
    width="600px"
    class="package-form"
    :title="!placeService ? 'Thêm mới dịch vụ' : 'Chỉnh sửa dịch vụ'"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-position="top" :rules="rules">
      <el-form-item label="Tên dịch vụ" prop="name">
        <el-input v-model="form.name" placeholder="Nhập vào tên dịch vụ"></el-input>
      </el-form-item>
      <el-form-item label="Loại địa điểm" prop="place_type">
        <el-select v-model="form.place_type" class="w-100" filterable placeholder="Chọn loại địa điểm">
          <el-option
            v-for="item in placeTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Nhóm tiện ích" prop="group_id">
        <el-select v-model="form.group_id" class="w-100" filterable clearable placeholder="Chọn nhóm tiện ích">
          <el-option
            v-for="item in placeFacilityGroups"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Avatar / Icon" prop="avatar_id">
        <el-row type="flex" align="middle" :gutter="12">
          <el-col :span="16">
            <el-input v-model="form.avatar_id" placeholder="Nhập avatar_id hoặc tải ảnh lên"></el-input>
          </el-col>
          <el-col :span="8">
            <el-upload
              action=""
              :show-file-list="false"
              :disabled="uploading"
              :http-request="handleUploadAvatar"
              accept="image/*"
            >
              <el-button size="small" type="success" :loading="uploading" icon="el-icon-upload2">
                Tải ảnh
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
        <div v-if="avatarPreviewUrl" class="mt-2 preview-avatar">
          <img :src="avatarPreviewUrl" alt="Avatar preview" />
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI || uploading" @click="handleClose">Hủy</el-button>
      <el-button type="primary" :loading="callingAPI" @click="handleUpdate">
        {{ !placeService ? 'Tạo' : 'Cập nhật' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import TYPE from '@/data/type'
import { createPlaceService, updatePlaceService } from '@/services/place/service'
import { createStorage } from '@/services/storage'
import { getTranslation } from '@/utils/filters'

export default {
  name: 'UpdatePlaceService',
  props: {
    placeService: Object,
    visible: Boolean,
    type: String
  },
  data() {
    return {
      callingAPI: false,
      uploading: false,
      placeTypes: TYPE.PLACES,
      avatarPreviewUrl: this.placeService && this.placeService.avatar ? this.placeService.avatar.url : '',
      form: {
        name: this.placeService ? this.placeService.name : '',
        place_type: this.placeService ? this.placeService.place_type : (this.type || ''),
        group_id: this.placeService ? this.placeService.group_id : '',
        avatar_id: this.placeService ? (this.placeService.avatar_id || '') : ''
      },
      rules: {
        name: [
          { required: true, message: 'Tên dịch vụ không được để trống', trigger: ['blur', 'change'] }
        ],
        place_type: [
          { required: true, message: 'Loại địa điểm không được để trống', trigger: ['blur', 'change'] }
        ],
        group_id: [
          { required: true, message: 'Nhóm dịch vụ không được để trống', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'constant']),
    placeFacilityGroups() {
      const groups = (this.constant && this.constant.constants && this.constant.constants.place_facility_groups) || []
      return groups.map((g) => ({
        ...g,
        name: getTranslation(g, this.language) ? getTranslation(g, this.language).name : g.name
      }))
    },
    dataInput() {
      const data = {
        name: this.form.name,
        locale: this.language,
        place_type: this.form.place_type,
        group_id: this.form.group_id,
        avatar_id: this.form.avatar_id
      }
      if (this.placeService) {
        data.id = this.placeService.id
      }
      return data
    }
  },
  methods: {
    handleUploadAvatar(fileInfo) {
      this.uploading = true
      const params = {
        file: fileInfo.file,
        objectId: this.placeService ? this.placeService.id : '',
        objectType: 'place_services',
        fileType: 'image',
        locale: this.language,
        isAvatar: true
      }
      createStorage(params).then((res) => {
        if (res && res.data) {
          this.form.avatar_id = res.data.id
          this.avatarPreviewUrl = res.data.url
          this.$notify.success({
            title: 'Thành công',
            message: 'Tải ảnh lên thành công'
          })
        }
        this.uploading = false
      }).catch((err) => {
        this.uploading = false
        this.$notify.error({
          title: 'Lỗi',
          message: (err && err.response && err.response.data && err.response.data.message) || 'Tải ảnh thất bại'
        })
      })
    },
    handleUpdate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          if (!this.placeService) {
            createPlaceService(this.dataInput).then(() => {
              this.$notify.success({
                title: 'Thành công',
                message: 'Tạo mới dịch vụ thành công'
              })
              this.$emit('reload')
              this.$emit('reload-constant')
              this.callingAPI = false
            }).catch(() => {
              this.callingAPI = false
            })
          } else {
            updatePlaceService(this.dataInput).then(() => {
              this.$notify.success({
                title: 'Thành công',
                message: 'Cập nhật dịch vụ thành công'
              })
              this.$emit('reload')
              this.$emit('reload-constant')
              this.callingAPI = false
            }).catch(() => {
              this.callingAPI = false
            })
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.preview-avatar {
  img {
    max-width: 80px;
    max-height: 80px;
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    object-fit: cover;
  }
}
</style>
